import { render, staticRenderFns } from "./KnowledgeBaseTab.vue?vue&type=template&id=31924470"
import script from "./KnowledgeBaseTab.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseTab.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseTab.vue?vue&type=style&index=0&id=31924470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports